export class SupervisingRequestUserStatusChange {
   public static readonly type = '[Supervising] Requesting User Status Change';

   constructor(public onBehalfOf: number, public status: number) {}
}

export class SupervisingChangeSkillStatus {
   public static readonly type = '[Supervising] Change Skill Status';

   constructor(public onBehalfOf: number, public skillId: number, public shouldSkillBeActive: boolean) {}
}
